import { render, staticRenderFns } from "./PropertyBooking.vue?vue&type=template&id=1c6b661a&scoped=true"
import script from "./PropertyBooking.vue?vue&type=script&lang=js"
export * from "./PropertyBooking.vue?vue&type=script&lang=js"
import style0 from "./PropertyBooking.vue?vue&type=style&index=0&id=1c6b661a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6b661a",
  null
  
)

export default component.exports